import styled from 'styled-components';

export const CommentProfilepic = styled.div`
  border-radius: 50%;
  height: 32px;
  min-height: 32px;
  min-width: 32px;
  object-fit: cover;
  overflow: hidden;
  width: 32px;
  vertical-align: baseline;
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const CommentMenu = styled.div`
  position: absolute;
  bottom: 100%;
  right: 0;
  padding: 0.25rem;
  gap: 0.35rem;
  display: none;
  background-color: white;
  border-radius: 100px 100px 0px 100px;
  outline: 1px solid lightgrey;
  z-index: 2;
`
export const CommentBody = styled.div`
  position: relative;
  width: fit-content;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background-color: var(--msg-box);
  &:hover {
    ${CommentMenu} {      
      display: flex;
    }
  }
`